import { gql } from "@apollo/client";

// Product List Query for shipping restrictions
export const SHIPPING_RESTRICTIONS_PRODUCT_LIST_QUERY = gql`
  query ShippingRestrictionsProductList(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $search: String
    $channel: String
  ) {
    products(
      first: $first
      after: $after
      last: $last
      before: $before
      search: $search
      channel: $channel
    ) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

// Update Product Metadata Mutation
export const UPDATE_SHIPPING_RESTRICTIONS_METADATA = gql`
  mutation UpdateShippingRestrictionsMetadata(
    $id: ID!
    $input: [MetadataInput!]!
    $keysToDelete: [String!]!
  ) {
    updateMetadata(
      id: $id
      input: $input
    ) {
      item {
        metadata {
          key
          value
        }
      }
      errors {
        field
        message
      }
    }
    deleteMetadata(
      id: $id
      keys: $keysToDelete
    ) {
      item {
        metadata {
          key
          value
        }
      }
      errors {
        field
        message
      }
    }
  }
`;

// Delete Product Metadata Mutation
export const DELETE_SHIPPING_RESTRICTIONS_METADATA = gql`
  mutation DeleteShippingRestrictionsMetadata(
    $id: ID!
    $keys: [String!]!
  ) {
    deleteMetadata(
      id: $id
      keys: $keys
    ) {
      item {
        metadata {
          key
          value
        }
      }
      errors {
        field
        message
      }
    }
  }
`;
// Shop id + metadata for the fulfillment window. Operation name is
// fulfillment-specific because html-manager already ships a `ShopMetadata`
// document, and two documents under one operation name confuse Apollo's cache
// and the codegen alike.
export const FULFILLMENT_SHOP_METADATA = gql`
  query FulfillmentShopMetadata {
    shop {
      id
      metadata {
        key
        value
      }
    }
  }
`;
